export default function WaveformBars({ active = true, count = 24, className = "" }) {
  return (
    <div className={`flex items-end justify-center gap-[3px] h-14 ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <span
          key={i}
          className="bar"
          style={{
            height: `${20 + (i % 5) * 12 + (active ? 0 : 0)}%`,
            animation: active ? `wave 1s ease-in-out ${i * 0.05}s infinite` : "none",
            opacity: active ? 1 : 0.45,
          }}
        />
      ))}
    </div>
  );
}
